export default "__VITE_ASSET__CKktdUdy__"